import { Component, OnInit, HostListener } from '@angular/core';
import { faFacebookF, faInstagram, faSnapchatGhost, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectdropdownService } from "src/app/services/selectdropdown.service";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "src/app/services/user.service";
import { ForgertpasswordService } from "src/app/services/forgertpassword.service";
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { callRtlStyle, removeRtlStyle } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ForgetpasswordmodalComponent } from 'src/app/components/forgetpasswordmodal/forgetpasswordmodal.component';
import { DialogService } from 'src/app/services/dialog.service';
import { SignInDialogComponentComponent } from '../sign-in-dialog-component/sign-in-dialog-component.component';
import { Dialog1Component } from '../dialog1/dialog1.component';
import { Dialog2Component } from '../dialog2/dialog2.component';
import { Dialog3Component } from '../dialog3/dialog3.component';
import { portalRequestCreate } from 'src/app/models/portalRequestCreate';
import { PortalUserDto } from 'src/app/models/portalUserDto';
import { AddrequestService } from "src/app/services/addrequest.service";
import { Globals } from 'src/app/globals';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [DatePipe]
})
export class HomeComponent implements OnInit {
  code: string | null = null;
  state: string | null = null;
  username: string | null = null;
  password: string | null = null;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(
    private datePipe: DatePipe,
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private userService: UserService,
    private dropdownsService: SelectdropdownService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private forgetModal: MatDialog,
    private AddrequestService: AddrequestService,
    private forgertpasswordService: ForgertpasswordService,
    private dialogService: DialogService,
    private dialog: MatDialog,private route: ActivatedRoute,
  ) { }
  // Slider
  customOptionsAr: OwlOptions;
  customOptionsEn: OwlOptions;
  slides1 = [
    { id: 1, icon: 'icon3.svg', text: 'مساعدة مالية' },
    { id: 2, icon: 'icon1.svg', text: 'مساعدة طبية' },
    { id: 3, icon: 'icon2.svg', text: 'مساعدات الطلبة ' },
    { id: 4, icon: 'icon3.svg', text: 'مساعدات عينية غذائية' },
  ]
  slides2 = [
    { id: 1, icon: 'icon1.svg', text: 'Financial asseistance' },
    { id: 2, icon: 'icon2.svg', text: 'Medical assistance' },
    { id: 3, icon: 'icon3.svg', text: 'School asseistance' },
    { id: 4, icon: 'icon3.svg', text: 'Food asseistance' },
  ]
  // =============
  icons = [
    { id: 1, icon: faFacebookF, name: 'فيس بوك', link: 'https://www.facebook.com/Fujcharity' },
    { id: 3, icon: faTwitter, name: 'تويتر', link: 'https://twitter.com/fujcharity' },
    { id: 2, icon: faYoutube, name: 'يوتيوب', link: 'https://www.youtube.com/channel/UCdmGlG452PIUVrqp9t8ddAA' },
    { id: 4, icon: faInstagram, name: 'انستقرام', link: 'https://www.instagram.com/fujcharity' }
  ];
  showRegister = false;
  showUpDatePassword = false;
  showCreateNewUser = false;
  showverify= false;
  login=true;
  registerForm: FormGroup;
  submittedRegister = false;
  loginForm: FormGroup;
  submittedLogin = false;
  reserPasswordForm: FormGroup;
  submittedreserPassword = false;
  createUserForm: FormGroup;
  submittedcreateUser = false;
  userData = new PortalUserDto();
  addrequet = new portalRequestCreate();
  dataResult: any;  // Class level variable to store the data.result



  get f() { return this.registerForm.controls; }
  get ff() { return (<FormGroup>this.registerForm.get('user')).controls }
  get l() { return this.loginForm.controls; }

  citiesList: any = [];
  genderList: any = [];
  maritalstatusList: any = [];
  nationalityList: any = [];

  loadingOverlay = false;

  emailAfterRegister = null;
  passAfterRegister = null;
  currentlang : any;
  UAEPassURL : any;

  lang: string;
  toastrMsgs: any;
  
  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.route.queryParams.subscribe(params => {
      this.code = params['code'];
      this.state = params['state'];
      if (this.isValidCodeState(this.code, this.state)) {
        this.uaepassCheckCode(this.code, this.state);
      } else {
        console.log('Code or state is invalid. API call not made.');
      }
    });
  
   
    this.sliderInit();
    this.dropdownsInit();
    this.getIconsName();
    this.getToastrMsgs();
    
    this.registerForm = this.formBuilder.group({
      birthDate: ['', Validators.required],
      genderLkpId: ['null', Validators.required],
      cityLkpId: ['null', Validators.required],
      region: ['', Validators.required],
      idNumber: ['', Validators.required],
      idExpirationDate: ['', Validators.required],
      maritalStatusLkpId: ['null', Validators.required],
      nationalityLkpId: ['null', Validators.required],
      mobileNumber1: ['', Validators.required],
      uuid: [''],
      user: this.formBuilder.group({
        name: ['', Validators.required],
        surname: ['', Validators.required],
        userName: ['', Validators.required],
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
        emailAddress: ['', [Validators.required, Validators.email]],
        uuid: [''],
      }, { validator: this.checkIfMatchingPasswords('password', 'confirmPassword') }),
    });
  
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  
    this.reserPasswordForm = this.formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      idn: [''],
      uuid: [''],
    }, { validator: this.checkIfMatchingPasswords('password', 'confirmPassword') });
  
    this.createUserForm = this.formBuilder.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      emailAddress: ['', [Validators.required, Validators.email]],
      idn: [''],
      uuid: [''],
    }, { validator: this.checkIfMatchingPasswords('password', 'confirmPassword') });
  }
  
  // Helper function to check if 'code' and 'state' are valid
  isValidCodeState(code: string, state: string): boolean {
    return code && state && code.trim() !== '' && state.trim() !== '';
  }
  
  ngOnDestroy() {
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  ngAfterViewInit() {
    document.getElementsByClassName('owl-dots')[0].className = 'owl-dots container text-md-left text-center';
    document.getElementsByClassName('owl-dots')[1].className = 'owl-dots container text-md-left text-center';
  }

  dropdownsInit() {
    // Cities Select Drop Down
    this.dropdownsService.GetCitiesList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.citiesList = data;
      })

    // Gender Select Drop Down
    this.dropdownsService.GetGenderList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.genderList = data;
      })

    // MaritalStatus Select Drop Down
    this.dropdownsService.GetMaritalStatusList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.maritalstatusList = data;
      })

    // Nationality Select Drop Down
    this.dropdownsService.GetNationalityList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.nationalityList = data;
        console.log(data);

      })
  }

  sliderInit() {
    this.customOptionsAr = {
      rtl: false,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      dots: true,
      navSpeed: 700,
      responsive: {
        0: {
          items: 1,
        },
        660: {
          items: 1,
          stagePadding: 150
        },
        900: {
          items: 2,
          stagePadding: 100
        },
        1160: {
          items: 3,
          stagePadding: 70
        },
        1520: {
          items: 4,
          stagePadding: 70
        }
      },
      nav: false
    }

    this.customOptionsEn = {
      rtl: true,
      mouseDrag: true,
      touchDrag: true,
      pullDrag: true,
      dots: true,
      navSpeed: 700,
      responsive: {
        0: {
          items: 1,
        },
        660: {
          items: 1,
          stagePadding: 150
        },
        900: {
          items: 2,
          stagePadding: 100
        },
        1160: {
          items: 3,
          stagePadding: 70
        },
        1520: {
          items: 4,
          stagePadding: 70
        }
      },
      nav: false
    }

  }

  getIconsName() {
    this.translate.get('Icons')
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.icons[0].name = data.facebook;
        this.icons[1].name = data.snapchat;
        this.icons[2].name = data.twitter;
        this.icons[3].name = data.whatsup;
      })
  }

  getToastrMsgs() {
    this.translate.get('ToastrSuccess')
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.toastrMsgs = data;
      })
  }

  changeLang(lang) {
    this.translate.use(lang)
    localStorage.setItem('lang', lang);
    this.lang = localStorage.getItem('lang');
    document.querySelector('html').lang = lang;
    if (lang == 'ar') {
      callRtlStyle();
    } else {
      removeRtlStyle();
    }
    this.getIconsName();
    this.dropdownsInit();
    this.getToastrMsgs();
  }
  
  onVerifyUser(): void{
//   window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=http://localhost:4200/"
 // window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stagingaid.fujcharity.ae/"
  window.location.href = "https://id.uaepass.ae/idshub/logout?redirect_uri=https://aid.fujcharity.ae/"
  }
  redirectToUaePass(): void {
    this.lang = localStorage.getItem('lang');
    if (this.lang === "ar") {
        this.currentlang = "ar";
    } else {
        this.currentlang = "en";
    }
    // Define the UAE Pass authorization URL
 // this.UAEPassURL = 'https://stg-id.uaepass.ae/idshub/authorize?response_type=code&client_id=sandbox_stage&scope=urn:uae:digitalid:profile:general&state=HnlHOJTkTb66Y5H&redirect_uri=http://localhost:4200&acr_values=urn:safelayer:tws:policies:authentication:level:low';
// this.UAEPassURL = 'https://stg-id.uaepass.ae/idshub/authorize?response_type=code&client_id=sandbox_stage&scope=urn:uae:digitalid:profile:general&state=HnlHOJTkTb66Y5H&redirect_uri=https://stagingaid.fujcharity.ae&acr_values=urn:safelayer:tws:policies:authentication:level:low';
  this.UAEPassURL = 'https://id.uaepass.ae/idshub/authorize?response_type=code&client_id=fuj_charity_web_prod&scope=urn:uae:digitalid:profile:general&state=PF3UVKnCPsj4jj3V&redirect_uri=https://aid.fujcharity.ae/&acr_values=urn:safelayer:tws:policies:authentication:level:low';
 window.location.href = `${this.UAEPassURL}&ui_locales=${this.currentlang}`;
}
  onSubmitRegister() {
    this.submittedRegister = true;
  
    const userGroup = <FormGroup>this.registerForm.get('user');
  
    if (userGroup.get('name') && userGroup.get('name').invalid) {
      this.toastr.error('Name is required');
      return;
    }
    if (userGroup.get('surname') && userGroup.get('surname').invalid) {
      this.toastr.error('Surname is required');
      return;
    }
    if (userGroup.get('emailAddress') && userGroup.get('emailAddress').invalid) {
      this.toastr.error('Email is required');
      return;
    }
    
    if (userGroup.get('userName') && userGroup.get('userName').invalid) {
      this.toastr.error('Username is required');
      return;
    }
    if (userGroup.get('password') && userGroup.get('password').invalid) {
      this.toastr.error('Password is required');
      return;
    }
    if (userGroup.get('confirmPassword') && userGroup.get('confirmPassword').invalid) {
      this.toastr.error('Password confirmation is required');
      return;
    }
    if (this.registerForm.get('birthDate') && this.registerForm.get('birthDate').invalid) {
      this.toastr.error('Birth date is required');
      return;
    }
   
    if (this.registerForm.get('genderLkpId') && this.registerForm.get('genderLkpId').invalid) {
      this.toastr.error('Gender is required');
      return;
    }
    if (this.registerForm.get('cityLkpId') && this.registerForm.get('cityLkpId').invalid) {
      this.toastr.error('City is required');
      return;
    }
    if (this.registerForm.get('region') && this.registerForm.get('region').invalid) {
      this.toastr.error('Region is required');
      return;
    }

    
    // Format and validate ID number
    debugger
  const idNumberControl = this.registerForm.get('idNumber');
  if (idNumberControl) {
    const idNumberRaw = idNumberControl.value;
    const formattedIdNumber = idNumberRaw.replace(/^(\d{3})(\d{4})(\d{7})(\d{1})$/, '$1-$2-$3-$4');
    idNumberControl.setValue(formattedIdNumber);

    const idNumberPattern = /^[0-9]{3}-[0-9]{4}-[0-9]{7}-[0-9]{1}$/;
    if (!idNumberPattern.test(formattedIdNumber)) {
      this.toastr.error('ID number format is invalid');
      return;
    }
  }
   
     if (this.registerForm.get('idExpirationDate') && this.registerForm.get('idExpirationDate').invalid) {
       this.toastr.error('ID expiration date is required');
       return;
     }
  
    if (this.registerForm.get('maritalStatusLkpId') && this.registerForm.get('maritalStatusLkpId').invalid) {
      this.toastr.error('Marital status is required');
      return;
    }
    if (this.registerForm.get('nationalityLkpId') && this.registerForm.get('nationalityLkpId').invalid) {
      this.toastr.error('Nationality is required');
      return;
    }
    if (this.registerForm.get('mobileNumber1') && this.registerForm.get('mobileNumber1').invalid) {
      this.toastr.error('Mobile number is required');
      return;
    }
   
    if ( userGroup.invalid) {
      return;
    } else {
      this.loadingOverlay = true;
      let submittingForm = this.registerForm.value;
      submittingForm.birthDate = this.datePipe.transform(submittingForm.birthDate, "dd/MM/yyyy");
      submittingForm.idExpirationDate = this.datePipe.transform(submittingForm.idExpirationDate, "dd/MM/yyyy");
      submittingForm.registrationDate = this.datePipe.transform(Date.now(), "dd/MM/yyyy");
      submittingForm.user.isActive = true;
      submittingForm.name = `${submittingForm.user.name}`;
      submittingForm.nameEn = `${submittingForm.user.surname}`;

      console.log('Processed submittingForm:', submittingForm);

      this.userService.addUser(submittingForm)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          console.log(data);
          this.toastr.success(this.toastrMsgs.newAccount);
          let dialogConfig = new MatDialogConfig();
          dialogConfig.position = { top: '0' };
          this.dialog.open(SignInDialogComponentComponent, dialogConfig);
          this.auth.GetTokenFromServer(submittingForm.user.userName, submittingForm.user.password)
            .pipe(takeUntil(this.destroy$))
            .subscribe(data => {
              this.auth.SetTokenToSessionStorage(data.result.accessToken);
              this.router.navigate(['board/main']);
            });
          this.loadingOverlay = false;
        }, error => {
          console.log(error);
          this.toastr.error(error.error.error.message);
          this.loadingOverlay = false;
        });
    }
  }
  genderDisplayText: string = '';
  nationalityDisplayText: string = '';
  uaepassCheckCode(code: string, state: string) {
    this.userService.UAEPASSProfile(code, state).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        console.log(data.result);
        if (data && data.result && data.result.uaePassLoginStatus == "Login") {
          this.toastr.success(this.toastrMsgs.login);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.position = { top: '0' };
          this.dialog.open(SignInDialogComponentComponent, dialogConfig);
          this.loadingOverlay = true;
          this.onSubmitLogin1(data.result.userName, data.result.password);
        }
        else if (data && data.result && data.result.uaePassLoginStatus == "Register") {
          this.showRegisterForm();  
          const genderResponse = (data.result.gender || '').toLowerCase(); 
          this.registerForm.patchValue({
            user: {
              name: (data.result.firstnameAR + ' ' + data.result.lastnameAR) || '',
              surname: (data.result.firstnameEN + ' ' + data.result.lastnameEN) || '',
              emailAddress: data.result.email || '', 
              uuid: data.result.uuid || '',
              userName: '',
              password: '',
              confirmPassword: ''
            }
          });
          this.registerForm.get('idNumber').setValue(data.result.idn || '');
          this.registerForm.get('mobileNumber1').setValue(data.result.mobile || '');
          this.registerForm.get('nationalityLkpId').setValue(data.result.nationalityLkpId || null);
          this.registerForm.get('uuid').setValue(data.result.uuid || null);

          if (this.lang === "ar") {
            this.nationalityDisplayText = data.result.nationalityAR;
          } else {
            this.nationalityDisplayText = data.result.nationalityEN;
          }
          // Handle gender mapping
          if (genderResponse === 'male') {
            this.registerForm.get('genderLkpId').setValue(122);
            this.genderDisplayText = 'Male';
          } else if (genderResponse === 'female') {
            this.registerForm.get('genderLkpId').setValue(123);
            this.genderDisplayText = 'Female';
          } else {
            this.registerForm.get('genderLkpId').setValue(null);
            this.genderDisplayText = '';
          }
        } 
        else if (data && data.result && data.result.uaePassLoginStatus == "CreateUser") {
          this.showCreateNewUserForm();  
          this.createUserForm.get('idn').setValue(data.result.idn || '');
          this.createUserForm.get('uuid').setValue(data.result.uuid || '');
        }
        else if (data && data.result && data.result.uaePassLoginStatus == "UpdatePassword") {
          this.showUpDatePasswordForm();  
          this.reserPasswordForm.get('userName').setValue(data.result.userName || '');
          this.reserPasswordForm.get('idn').setValue(data.result.idn || '');
          this.reserPasswordForm.get('uuid').setValue(data.result.uuid || '');


        }
        else if (data && data.result && data.result.uaePassLoginStatus == "UAEPassNotVerified") {
          this.showverifyPasswordForm();  
        }
        else if (data && data.result && data.result.uaePassLoginStatus == "AuthorisationError") {
          this.toastr.error("Access Token Error");
       //  window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=http://localhost:4200/"
     //   window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stagingaid.fujcharity.ae/"
       window.location.href = "https://id.uaepass.ae/idshub/logout?redirect_uri=https://aid.fujcharity.ae/"
      

        }
        else if (data && data.result && data.result.uaePassLoginStatus == "UserInfoError") {
          this.toastr.error("UserInfo Not Found");
       //   window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=http://localhost:4200/"
      //   window.location.href = "https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stagingaid.fujcharity.ae/"
         window.location.href = "https://id.uaepass.ae/idshub/logout?redirect_uri=https://aid.fujcharity.ae/"
        }
      },
      (error) => {
        console.error("Error:", error.error.error);
        this.router.navigate(['/home']);
      }
    );
  }
  onSubmitLogin1(userName: string, password: string) {
    this.loginForm.get('email').setValue(userName);
    this.loginForm.get('password').setValue(password);
    this.loginForm.updateValueAndValidity();
    this.submittedLogin = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      this.loadingOverlay = true;
      this.auth.GetTokenFromServer(userName, password)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (data) => {
            console.log(data.result);
            this.toastr.success(this.toastrMsgs.login);
  
            let dialogConfig = new MatDialogConfig();
            dialogConfig.position = { top: '0' };
            this.dialog.open(SignInDialogComponentComponent, dialogConfig);
  
            this.loadingOverlay = false;
            this.auth.SetTokenToSessionStorage(data.result.accessToken);
            this.router.navigate(['board/main']);
          },
          (error) => {
            console.log(error.error.error);
            this.toastr.error(error.error.error.details);
            this.loadingOverlay = false;
          }
        );
    }
  }
  onSubmitLogin() {
    this.submittedLogin = true;
    if (this.loginForm.invalid) {
      return;
    } else {
      this.loadingOverlay = true;
      let email = this.loginForm.get('email').value;
      let password = this.loginForm.get('password').value;

      this.auth.GetTokenFromServer(email, password)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          console.log(data.result);
          this.toastr.success(this.toastrMsgs.login);

            let dialogConfig = new MatDialogConfig();
            dialogConfig.position = { top: '0'};
            this.dialog.open(SignInDialogComponentComponent, dialogConfig);
          
          this.loadingOverlay = false;
          this.auth.SetTokenToSessionStorage(data.result.accessToken)
          this.router.navigate(['board/main']);
        }, error => {
          console.log(error.error.error);
          this.toastr.error(error.error.error.details);
          this.loadingOverlay = false;
        })
    }
  }
  onSubmitCreateUser() {
    debugger
    this.submittedcreateUser = true;
    const userGroup = <FormGroup>this.createUserForm.get('user');
    if (this.createUserForm.get('name') && this.createUserForm.get('name').invalid) {
      this.toastr.error('Name is required');
      return;
    }
    if (this.createUserForm.get('surname') && this.createUserForm.get('surname').invalid) {
      this.toastr.error('Surname is required');
      return;
    }
    if (this.createUserForm.get('emailAddress') && this.createUserForm.get('emailAddress').invalid) {
      this.toastr.error('Email is required');
      return;
    }
    
    if (this.createUserForm.get('userName') && this.createUserForm.get('userName').invalid) {
      this.toastr.error('Username is required');
      return;
    }
    if (this.createUserForm.get('password') && this.createUserForm.get('password').invalid) {
      this.toastr.error('Password is required');
      return;
    }
    if (this.createUserForm.get('confirmPassword') && this.createUserForm.get('confirmPassword').invalid) {
      this.toastr.error('Password confirmation is required');
      return;
    }
    if (this.createUserForm.invalid) {
      return;
    } else {
      this.loadingOverlay = true;
      let submittingForm = this.createUserForm.value;
      submittingForm.isActive = true;
      console.log('Processed submittingForm:', submittingForm);
      debugger
      this.userService.UpdateUserForUAEPass(submittingForm)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          console.log(data);
          this.toastr.success(this.toastrMsgs.newAccount);
          this.toastr.success(this.toastrMsgs.login);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.position = { top: '0' };
          this.dialog.open(SignInDialogComponentComponent, dialogConfig);
          this.loadingOverlay = true;
          this.onSubmitLogin1(data.result.userName, data.result.password);
          this.loadingOverlay = false;
        }, error => {
          console.log(error);
          this.toastr.error(error.error.error.message);
          this.loadingOverlay = false;
        });
    }
  }
  onSubmitupdateUser() {
    debugger
    this.submittedreserPassword = true;  
    
    if (this.reserPasswordForm.get('userName') && this.reserPasswordForm.get('userName').invalid) {
      this.toastr.error('Username is required');
      return;
    }
    if (this.reserPasswordForm.get('password') && this.reserPasswordForm.get('password').invalid) {
      this.toastr.error('Password is required');
      return;
    }
    if (this.reserPasswordForm.get('confirmPassword') && this.reserPasswordForm.get('confirmPassword').invalid) {
      this.toastr.error('Password confirmation is required');
      return;
    }
    if (this.reserPasswordForm.invalid) {
      return;
    } else {
      this.loadingOverlay = true;
      let submittingForm = this.reserPasswordForm.value;
      console.log('Processed submittingForm:', submittingForm);
      debugger
      this.userService.UpdateUserForUAEPass(submittingForm)
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
          console.log(data);
          this.toastr.success(this.toastrMsgs.newAccount);
          this.toastr.success(this.toastrMsgs.login);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.position = { top: '0' };
          this.dialog.open(SignInDialogComponentComponent, dialogConfig);
          this.loadingOverlay = true;
          this.onSubmitLogin1(data.result.userName, data.result.password);
          this.loadingOverlay = false;
        }, error => {
          console.log(error);
          this.toastr.error(error.error.error.message);
          this.loadingOverlay = false;
        });
    }
  }
  sendForgetPasswordEmail(email) {
    this.loadingOverlay = true;
    this.forgertpasswordService.sendEmail(email)
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        this.toastr.success(this.toastrMsgs.checkEmail);
        this.loadingOverlay = false;
      }, error => {
        this.toastr.error(this.toastrMsgs.invalidEmail);
        this.loadingOverlay = false;
      })
  }
  resetRegisterForm() {
    this.submittedRegister = false;
    this.registerForm.reset();
  }
  resetLoginForm() {
    this.submittedLogin = false;
    this.loginForm.reset();
  }
  resetcreateNewUser() {
    this.submittedcreateUser = false;
    this.createUserForm.reset();
  }
  resetupDatePassForm() {
    this.submittedreserPassword = false;
    this.reserPasswordForm.reset();
  }
  @HostListener('window:resize', [])
  onResize() {
    this.isLargeScreen()
  }

  @HostListener('wheel', ['$event'])
  handleWheelEvent(event) {
    if (this.loadingOverlay) {
      event.preventDefault();
    }
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      let passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value || !passwordInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true })
      }
      else {
        return passwordConfirmationInput.setErrors(null);
      }
    }
  }

  isLargeScreen() {
    if (window.innerWidth > 768) {
      return true;
    } else {
      return false;
    }
  }

  goToLogin() {
    let el = document.getElementById('login');
    el.scrollIntoView({ behavior: 'smooth' });
  }

  goToBoard() {
    this.router.navigate(['board']);
  }

  showRegisterForm() {
    this.showRegister = true;
    this.showCreateNewUser = false;
    this.showUpDatePassword = false;
    this.login=false;
    this.resetRegisterForm();
    this.resetLoginForm();
  }
  showLoginForm() {
    this.showRegister = false;
    this.showCreateNewUser = false;
    this.showUpDatePassword = false;
    this.login=true;
    this.resetRegisterForm();
    this.resetLoginForm();
  }
  showCreateNewUserForm() {
    this.showRegister = false;
    this.showUpDatePassword = false;
    this.showCreateNewUser = true;
    this.login=false;
   this.resetRegisterForm();
    this.resetLoginForm();
    this.resetupDatePassForm();
    this.resetcreateNewUser();
  }
  showUpDatePasswordForm() {
    this.showUpDatePassword = true;
    this.showRegister = false;
    this.showCreateNewUser = false;
    this.login=false;
    this.resetRegisterForm();
    this.resetLoginForm();
  }
  showverifyPasswordForm() {
    this.showverify= true;
    this.showUpDatePassword = false;
    this.showRegister = false;
    this.showCreateNewUser = false;
    this.login=false;
  }
  showForgetPassword() {
    let matDialog = new MatDialogConfig();
    matDialog.disableClose = true;
    matDialog.maxWidth = "450px";
    this.forgetModal.open(ForgetpasswordmodalComponent, matDialog)
      .afterClosed().subscribe(res => {
        if (res != null) {
          this.sendForgetPasswordEmail(res);
        } else {
          return false
        }
      });
  }

  opendialog1() {
    let dialogConfig1 = new MatDialogConfig();
    dialogConfig1.position = {
      bottom: '170px'
    };
    this.dialog.open(Dialog1Component, dialogConfig1)
  }
  opendialog2() {
    let dialogConfig2 = new MatDialogConfig();
    dialogConfig2.position = {
      bottom: '170px'
    };
    this.dialog.open(Dialog2Component, dialogConfig2)
  }
  opendialog3() {
    let dialogConfig3 = new MatDialogConfig();
    dialogConfig3.position = {
      bottom: '170px'
    };
    this.dialog.open(Dialog3Component, dialogConfig3)
  }




}
